/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateBotByIdOptions, UpdateBotByIdResponses } from '../types/UpdateBotById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update bot by ID
 * {@link /v1/bots/:bot_id}
 */
export function updateBotById<ThrowOnError extends boolean = true>(
  options: Options<UpdateBotByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateBotByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/bots/{bot_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateBotByIdResponses, ThrowOnError>>,
  )
}
